import { Controller } from "@hotwired/stimulus"

// Generic controller for reloading Turbo Frames when Bootstrap tabs are clicked
// Useful for lazy-loading tab content and ensuring fresh data on each tab view
//
// This controller specifically works with Bootstrap 5's tab component and its
// 'shown.bs.tab' event system.
//
// Usage:
//   <div data-controller="tab-reload">
//     <button data-tab-reload-target="trigger"
//             data-bs-toggle="tab"
//             data-bs-target="#my-tab">
//       Tab
//     </button>
//
//     <div class="tab-content">
//       <div id="my-tab" class="tab-pane">
//         <turbo-frame data-tab-reload-target="frame" src="/path"></turbo-frame>
//       </div>
//     </div>
//   </div>
//
// When the trigger tab is shown (via Bootstrap's tab system), the associated frame will reload
export default class extends Controller {
  static targets = ["trigger", "frame"]

  connect() {
    if (!this.hasTriggerTarget) {
      console.warn("tab-reload controller: no trigger target found")
      return
    }

    if (!this.hasFrameTarget) {
      console.warn("tab-reload controller: no frame target found")
      return
    }

    // Bind the reload handler to Bootstrap's tab shown event
    this.boundReloadFrame = this.reloadFrame.bind(this)
    this.triggerTarget.addEventListener('shown.bs.tab', this.boundReloadFrame)
  }

  disconnect() {
    if (this.hasTriggerTarget && this.boundReloadFrame) {
      this.triggerTarget.removeEventListener('shown.bs.tab', this.boundReloadFrame)
    }
  }

  reloadFrame(event) {
    if (!this.hasFrameTarget) {
      console.warn("tab-reload controller: frame target not available for reload")
      return
    }

    const frame = this.frameTarget

    if (!frame.src) {
      console.warn("tab-reload controller: frame has no src attribute to reload")
      return
    }

    // Reload the Turbo Frame by calling its reload method
    // This triggers a fresh fetch from the server
    frame.reload()
  }
}
